var map = {
	"./auth-side.svg": 2068,
	"./backgroundlogo.svg": 4623,
	"./logo-dd.svg": 4880,
	"./logo-displaydeck.svg": 5149,
	"./svg/icons/arrow_left.svg": 3556,
	"./svg/icons/arrow_right.svg": 219,
	"./svg/icons/arrow_right_lucide.svg": 4218,
	"./svg/icons/arrows_up_down.svg": 9272,
	"./svg/icons/calendar.svg": 3060,
	"./svg/icons/caret_down.svg": 9221,
	"./svg/icons/caret_left.svg": 5166,
	"./svg/icons/caret_right.svg": 5677,
	"./svg/icons/check.svg": 1691,
	"./svg/icons/chevron_down.svg": 7009,
	"./svg/icons/display_logo.svg": 2269,
	"./svg/icons/edit_dots.svg": 7304,
	"./svg/icons/error.svg": 8029,
	"./svg/icons/eye.svg": 4704,
	"./svg/icons/eye_off.svg": 686,
	"./svg/icons/filetype_folder.svg": 3766,
	"./svg/icons/filetype_generated.svg": 2097,
	"./svg/icons/filetype_group.svg": 7583,
	"./svg/icons/filetype_set.svg": 6606,
	"./svg/icons/filetype_single_image.svg": 2004,
	"./svg/icons/filetype_single_pdf.svg": 8005,
	"./svg/icons/filetype_single_video.svg": 4126,
	"./svg/icons/home.svg": 532,
	"./svg/icons/hourglass.svg": 9029,
	"./svg/icons/info.svg": 7865,
	"./svg/icons/list.svg": 3909,
	"./svg/icons/log_out.svg": 8404,
	"./svg/icons/logout.svg": 8619,
	"./svg/icons/menu.svg": 7184,
	"./svg/icons/nav_dashboard.svg": 5473,
	"./svg/icons/nav_displays.svg": 4358,
	"./svg/icons/nav_generator.svg": 1446,
	"./svg/icons/nav_media.svg": 9897,
	"./svg/icons/nav_playlists.svg": 7760,
	"./svg/icons/nav_redaktion.svg": 3898,
	"./svg/icons/nav_settings.svg": 736,
	"./svg/icons/nav_users.svg": 6425,
	"./svg/icons/sorting.svg": 1803,
	"./svg/icons/success.svg": 2110,
	"./svg/icons/tiles.svg": 5592,
	"./svg/icons/times.svg": 5477,
	"./svg/icons/trash.svg": 297,
	"./svg/icons/trash_outline.svg": 4438,
	"./svg/icons/upload.svg": 2030,
	"./svg/icons/warning.svg": 9251,
	"./svg/icons/x.svg": 1967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;